import { ArrowRight, ArrowUpRight, MapPin, BedDouble } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/Reveal";
import { PROJECTS_GROUPS } from "@/lib/projectsData";

// Show 6 featured recent projects
const FEATURED = PROJECTS_GROUPS.flatMap((g) =>
  g.areas.flatMap((a) => a.items.map((p) => ({ ...p, area: a.area, city: g.city })))
).slice(0, 6);

export const RecentProjects = () => {
  return (
    <section
      data-testid="recent-projects"
      className="py-24 lg:py-32 bg-[#F5F5F5]"
    >
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
            <div className="max-w-3xl">
              <span className="text-xs uppercase tracking-[0.22em] text-[#707070]">
                Recent Projects
              </span>
              <h2 className="font-display mt-4 text-4xl lg:text-[48px] font-extrabold leading-[1.05] tracking-tight text-[#1C1C1C]">
                Spaces We've
                <br />
                <span className="text-[#13294B]">Transformed Recently.</span>
              </h2>
            </div>
            <Link
              to="/projects"
              className="text-[15px] font-medium text-[#13294B] hover:underline underline-offset-4"
            >
              View full portfolio →
            </Link>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURED.map((p, i) => (
            <Reveal key={p.link} delay={(i % 3) * 0.06}>
              <a
                href={p.link}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`home-recent-${i}`}
                className="group block bg-white rounded-3xl overflow-hidden border border-black/5 hover:border-[#13294B]/25 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_rgba(19,41,75,0.12)] transition-all duration-500"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-[1.4s] ease-out"
                  />
                  <div className="absolute top-4 left-4 bg-white/95 backdrop-blur px-3 py-1.5 rounded-full text-[11px] font-semibold text-[#13294B] tracking-[0.12em] flex items-center gap-1.5">
                    <BedDouble size={12} /> {p.bhk}
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.22em] text-[#707070]">
                    <MapPin size={11} /> {p.area} · {p.city}
                  </div>
                  <h4 className="font-display mt-2 text-[18px] font-bold text-[#1C1C1C] leading-tight">
                    {p.title}
                  </h4>
                  <div className="mt-4 inline-flex items-center gap-1.5 text-[13px] font-medium text-[#13294B] group-hover:gap-2 transition-all">
                    View on Airbnb <ArrowUpRight size={14} />
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
